import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component – wraps react-helmet-async with sensible defaults for asisant.
 *
 * Props:
 *  - title:         page-specific title; appended with " | asisant"
 *  - description:   meta description (max ~160 chars recommended)
 *  - keywords:      optional comma-separated keywords
 *  - canonical:     absolute path (e.g. /modulos/csp-billing)
 *  - image:         OG/Twitter image URL
 *  - type:          og:type (default "website")
 *  - structuredData: JSON-LD object to inject as <script>
 */
const SITE_URL = 'https://asisant.com';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/zw52s0v6_logo_color.png';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  structuredData,
}) => {
  const fullTitle = title ? `${title} | asisant` : 'asisant · Plataforma cloud para operar clientes, marketplace y provisionamiento';
  const url = canonical ? `${SITE_URL}${canonical}` : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="asisant" />
      <meta property="og:locale" content="es_ES" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {/* Structured data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
